
<section
  id="enjuapp"
  class="l-enjuapp"
>
  <div class="o-container">
    <div class="o-separator -line -gray t-xs-hide t-md-block">
      <hr>
    </div>

    <div class="o-grid -xs-middle -xs-full -xs-between">
      <div class="o-grid__item l-bag__grid -xs-24 -md-11">
        <h2 class="l-enjuapp__title">
          não deixe pra baixar amanhã o que você pode baixar agora
        </h2>

        <h3 class="l-enjuapp__subtitle">
          mais que um app. é o enju-app.
        </h3>

        <p class="l-enjuapp__description">
          descontos relâmpagos, agilidade na negociação
          <span class="t-md-block">
            e promos exclusivas. é fogo no parquinho.
          </span>
        </p>

        <a
          v-webview-open-universal-link="'none'"
          href="/app"
        >
          <button
            class="l-enjuapp__button o-button -xs-large -xs-secondary t-xs-block t-md-hide"
          >

            baixar o enjuapp
          </button>
        </a>

        <a
          href="https://apps.apple.com/us/app/enjoei-comprar-e-vender-roupa/id783409492"
          target="_blank"
          class="l-action-desktop"
        >
          <button
            class="l-enjuapp__button-desktop o-button -xs-large -xs-secondary t-xs-hide t-md-block"
          >

            <vIcon
              class="l-enjuapp__button-icon"
              name="apple"
              size="medium"
              color="dark"
            />

            baixar na app store
          </button>
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=br.com.enjoei.app&hl=pt_BR&gl=US"
          target="_blank"
          class="l-action-desktop"
        >
          <button
            class="l-enjuapp__button-desktop o-button -xs-large -xs-secondary t-xs-hide t-md-block"
          >

            <img
              class="l-enjuapp__button-image"
              :src="`${require('@@/assets/images/landing-pages/how-to/enjuapp/google-play.png')}`"
              alt="Logo ilustrativo da Google Play Store"
            >

            baixar na google play
          </button>
        </a>
      </div>

      <div class="o-grid__item l-bag__grid -xs-24 -md-13">
        <div class="l-enjuapp__wrapper">
          <figure class="l-enjuapp__figure l-figure">
            <picture>
              <source
                :srcset="`
                  ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphone-xs.png')},
                  ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphone-xs@2x.png')} 2x
                `"
                media="(max-width: 899px)"
              >

              <source
                :srcset="`
                  ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphones-md.png')},
                  ${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphones-md@2x.png')} 2x
                `"
                media="(min-width: 900px)"
              >

              <img
                class="l-image"
                :src="`${require('@@/assets/images/landing-pages/how-to/enjuapp/cellphones-md.png')}`"
                alt="Imagem ilustrativa de um celular exibindo a página inicial do aplicativo do enjoei."
              >
            </picture>
          </figure>
        </div>
      </div>
    </div>

    <div class="o-separator -line -gray t-xs-hide t-md-block">
      <hr>
    </div>

    <div class="l-enjuapp__prefooter">
      <a
        v-webview-open-universal-link="'none'"
        :href="content.actionLink"
        class="l-enjuapp__action o-button -xs-large -xs-primary"
      >
        {{ content.actionText }}
      </a>
    </div>
  </div>
</section>
